import { Slot, Logo } from '@costar-ui/components';
import React, { useMemo } from 'react';
import { Address } from './address.esm.js';
import { Awards } from './awards.esm.js';
import { Company } from './company.esm.js';
import { Designation } from './designation.esm.js';
import { JobTitle } from './job-title.esm.js';
import { MailtoLink } from './mailto-link.esm.js';
import { Name } from './name.esm.js';
import { Phone } from './phone.esm.js';
import { Specialties } from './specialties.esm.js';
import { WebsiteLink } from './website-link.esm.js';
import SocialIconLinks from '../social-icon-links/social-icon-links.esm.js';

var onLinkClick = function onLinkClick(e) {
  return e.stopPropagation();
};
var Details = function Details(props) {
  var name = props.name,
    jobTitle = props.jobTitle,
    designation = props.designation,
    company = props.company,
    address = props.address,
    phone = props.phone,
    mailtoLink = props.mailtoLink,
    socialIconLinks = props.socialIconLinks,
    website = props.website,
    specialties = props.specialties,
    awards = props.awards,
    companyLogo = props.companyLogo,
    _props$isLoading = props.isLoading,
    isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
    testId = props.testId;
  var awardsComponent = useMemo(function () {
    return /*#__PURE__*/React.createElement(Awards, {
      powerBroker: awards === null || awards === void 0 ? void 0 : awards.powerBroker,
      costarAward: awards === null || awards === void 0 ? void 0 : awards.costarAward,
      impactAward: awards === null || awards === void 0 ? void 0 : awards.impactAward,
      labels: awards === null || awards === void 0 ? void 0 : awards.labels,
      isLoading: isLoading,
      testId: "awards"
    });
  }, [awards === null || awards === void 0 ? void 0 : awards.costarAward, awards === null || awards === void 0 ? void 0 : awards.impactAward, awards === null || awards === void 0 ? void 0 : awards.labels, awards === null || awards === void 0 ? void 0 : awards.powerBroker, isLoading]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, name || jobTitle || designation ? /*#__PURE__*/React.createElement(Slot, {
    gap: isLoading ? 'xs' : undefined,
    direction: "vertical",
    testId: testId
  }, /*#__PURE__*/React.createElement(Name, {
    label: name === null || name === void 0 ? void 0 : name.label,
    href: name === null || name === void 0 ? void 0 : name.href,
    onNameClick: name === null || name === void 0 ? void 0 : name.onNameClick,
    isLoading: isLoading,
    testId: "contact-name"
  }), /*#__PURE__*/React.createElement(JobTitle, {
    label: jobTitle === null || jobTitle === void 0 ? void 0 : jobTitle.label,
    isLoading: isLoading,
    testId: "contact-job-title"
  }), /*#__PURE__*/React.createElement(Designation, {
    hqLocation: designation === null || designation === void 0 ? void 0 : designation.hqLocation,
    companyType: designation === null || designation === void 0 ? void 0 : designation.companyType,
    isLoading: isLoading,
    testId: "company-designation"
  })) : null, companyLogo || address || phone || mailtoLink || awards || socialIconLinks || website || specialties ? /*#__PURE__*/React.createElement(Slot, {
    direction: "vertical",
    gap: "xs"
  }, /*#__PURE__*/React.createElement(Company, {
    name: company === null || company === void 0 ? void 0 : company.name,
    currentlyWithLabel: company === null || company === void 0 ? void 0 : company.currentlyWithLabel,
    linkHref: company === null || company === void 0 ? void 0 : company.linkHref,
    onClick: onLinkClick,
    isLoading: isLoading,
    testId: "company-name"
  }), /*#__PURE__*/React.createElement(Address, {
    lines: address === null || address === void 0 ? void 0 : address.lines,
    isLoading: isLoading,
    testId: "address"
  }), phone || mailtoLink ? /*#__PURE__*/React.createElement(Slot, {
    direction: "vertical",
    testId: "contact-credentials"
  }, /*#__PURE__*/React.createElement(Phone, {
    labels: phone === null || phone === void 0 ? void 0 : phone.labels,
    numbers: phone === null || phone === void 0 ? void 0 : phone.numbers,
    isLoading: isLoading,
    skeletonCount: 4,
    testId: "contact-phone-numbers"
  }), /*#__PURE__*/React.createElement(MailtoLink, {
    email: mailtoLink === null || mailtoLink === void 0 ? void 0 : mailtoLink.email,
    isLoading: isLoading,
    testId: "contact-mail-to-link"
  })) : null, /*#__PURE__*/React.createElement(SocialIconLinks, {
    vCard: socialIconLinks === null || socialIconLinks === void 0 ? void 0 : socialIconLinks.vCard,
    linkedInProfile: socialIconLinks === null || socialIconLinks === void 0 ? void 0 : socialIconLinks.linkedInProfile,
    isLoading: isLoading,
    testId: "contact-social-icon-links"
  }), /*#__PURE__*/React.createElement(WebsiteLink, {
    url: website === null || website === void 0 ? void 0 : website.url,
    isLoading: isLoading,
    onClick: onLinkClick,
    testId: "company-website-link"
  }), /*#__PURE__*/React.createElement(Specialties, {
    primarySpecialty: specialties === null || specialties === void 0 ? void 0 : specialties.primarySpecialty,
    specialties: specialties === null || specialties === void 0 ? void 0 : specialties.specialties,
    isLoading: isLoading,
    testId: "specialties"
  })) : null, companyLogo || awards ? /*#__PURE__*/React.createElement(Slot, {
    direction: "vertical"
  }, companyLogo !== null && companyLogo !== void 0 && companyLogo.src || awards !== null && awards !== void 0 && awards.costarAward || awards !== null && awards !== void 0 && awards.impactAward || awards !== null && awards !== void 0 && awards.powerBroker && !isLoading ? /*#__PURE__*/React.createElement(Slot, {
    direction: "vertical",
    gap: "lg"
  }, awardsComponent, companyLogo !== null && companyLogo !== void 0 && companyLogo.src ? /*#__PURE__*/React.createElement(Logo, {
    size: "lg",
    src: companyLogo === null || companyLogo === void 0 ? void 0 : companyLogo.src,
    alt: companyLogo === null || companyLogo === void 0 ? void 0 : companyLogo.alt,
    title: companyLogo === null || companyLogo === void 0 ? void 0 : companyLogo.title,
    testId: "company-logo",
    suppressOnImageError: true
  }) : null) : awardsComponent) : null);
};

export { Details };
//# sourceMappingURL=details.esm.js.map
